import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createOrder } from "../../api";

export const sendOrderAsyncThunk = createAsyncThunk("sendOrderAsync", (data) => createOrder(data));

let initialState = {
  isError: null,
  isPending: null,
  selectedStudio: null,
  selectedCatService: null,
  selectedMaster: null,
  selectedService: null,
  selectedDate: null,
  selectedTime: null,
  selectedPaymentType: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    changeSelectedStudio: (state, { payload }) => {
      state.selectedStudio = payload;
      state.selectedCatService = null;
      state.selectedMaster = null;
    },
    changeselectedCatService: (state, { payload }) => {
      state.selectedCatService = payload;
      state.selectedMaster = null;
    },
    changeSelectedMaster: (state, { payload }) => {
      state.selectedMaster = payload;
    },
    changeSelectedService: (state, { payload }) => {
      state.selectedService = payload;
    },
    changeSelectedDate: (state, { payload }) => {
      state.selectedDate = payload;
      state.selectedTime = null;
    },
    changeSelectedTime: (state, { payload }) => {
      state.selectedTime = payload;
    },
    changeSelectedPaymentType: (state, { payload }) => {
      state.selectedPaymentType = payload;
    },
    clearOrder: (state, { payload }) => {
      state.selectedStudio = null;
      state.selectedCatService = null;
      state.selectedMaster = null;
      state.selectedService = null;
      state.selectedDate = null;
      state.selectedTime = null;
      state.selectedPaymentType = null;
    },
  },
  extraReducers: {
    [sendOrderAsyncThunk.pending]: (state, action) => {
      state.isError = false;
      state.isPending = true;
    },
    [sendOrderAsyncThunk.fulfilled]: (state, action) => {
      state.selectedStudio = null;
      state.selectedCatService = null;
      state.selectedMaster = null;
      state.selectedService = null;
      state.selectedDate = null;
      state.selectedTime = null;
      state.selectedPaymentType = null;
    },
    [sendOrderAsyncThunk.rejected]: (state, action) => {
      state.isError = true;
      state.isPending = false;
    },
  },
});

export const {
  changeSelectedStudio,
  changeselectedCatService,
  changeSelectedMaster,
  changeSelectedService,
  changeSelectedDate,
  changeSelectedTime,
  changeSelectedPaymentType,
  clearOrder,
} = orderSlice.actions;
export const orderReducer = orderSlice.reducer;
